<div
  class="choose-dialog-container"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <div class="flex justify-start w-full mb-2">
    <ddc-text-gradient
      class="text-2xl"
      *ngIf="!_editedField && !_editError && !_isEditBtnLoading"
      [_icon]="'bookmark_border'"
      [_text]="'Bookmark'"
      [_type]="'1'"
    ></ddc-text-gradient>
  </div>
  <mat-divider class="mb-2" *ngIf="!_editedField && !_editError && !_isEditBtnLoading"></mat-divider>
  <!-- ! Add Form -->
  <form class="choose-dialog-form" [formGroup]="_form">
    <!-- ! Form Error -->
    <div class="alert alert-danger" *ngIf="_editError">
      {{ _editError }}
    </div>
    @if (_editedField && !_addedWithoutColl) {
      <div>
        <div class="alert alert-success success-msg">
          <div>
            <ng-lottie width="25px" [options]="options"></ng-lottie>
          </div>
          <div>Bookmarked to collection.</div>
        </div>
      </div>
    } @else if (_addedWithoutColl) {
      <div>
        <div class="alert alert-success success-msg">
          <div>
            <ng-lottie width="25px" [options]="options"></ng-lottie>
          </div>
          <div>Bookmarked without collection.</div>
        </div>
      </div>
    }
    <!-- ! Options -->
    <div class="choose-dialog-data" *ngIf="!_editedField && !_editError && !_isEditBtnLoading">
      <mat-form-field class="choose-options-container">
        <mat-label>Choose Collection</mat-label>
        <mat-select formControlName="_option">
          <mat-option *ngFor="let option of _options" [value]="option.id">
            {{ option.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ! Footer -->
    <mat-divider style="margin-bottom: 10px"></mat-divider>
    <div class="choose-dialog-submit-container">
      <div class="choose-dialog-submit-container-right" [style.margin-left]="_editedField ? 'auto' : null">
        <!-- Cancel -->
        <button class="choose-dialog-close-btn" *ngIf="!_editError" mat-button type="button" (click)="add(false)">
          {{ _editedField ? 'Close' : 'Add without collection' }}
        </button>
      </div>
      <div class="choose-dialog-submit-container-left">
        <!-- Edit -->
        <ddc-button-s-one
          class="ddc-submit-btn"
          *ngIf="!_editedField && !_editError"
          [_isLoading]="_isEditBtnLoading"
          [_label]="_submitBtnText"
          (click)="add(true)"
        ></ddc-button-s-one>
        <ddc-button-u-one
          *ngIf="_editError"
          [_dynamicRoute]="'/pricing'"
          [_hasBorder]="true"
          [_icon]="'auto_awesome'"
          [_label]="'Upgrade'"
          (click)="closeDialog()"
        ></ddc-button-u-one>
      </div>
    </div>
  </form>
</div>
